export const isDev = () => {
    return !process.env.production
}
